import {
    Card,
    CardContent,
    Typography,
    Button,
    ButtonGroup,
    Box
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ArchiveIcon from '@mui/icons-material/Archive';
import ClearIcon from '@mui/icons-material/Clear';
import { useQueryClient } from '@tanstack/react-query';

const ControlPanel = ({
    onProcessQueue,
    onArchiveMessages,
    onClearFailed,
    environment,
    onEnvironmentToggle
}) => {
    const queryClient = useQueryClient();
    const environments = [ 'dev', 'staging', 'production' ];

    const getEnvironmentColor = (env) => {
        switch (env) {
            case 'dev': return 'info';
            case 'staging': return 'warning';
            case 'production': return 'success';
            default: return 'default';
        }
    };

    return (
        <Card sx={ { mb: 3 } }>
            <CardContent>
                <Box sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 } }>
                    <Typography variant="h6">System Controls</Typography>

                    <Box sx={ { display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' } }>
                        <Box sx={ { display: 'flex', alignItems: 'center', gap: 1 } }>
                            <Typography variant="body2">Environment:</Typography>
                                <ButtonGroup size="small">
                                { environments.map((env) => (
                                    <Button
                                        key={ env }
                                        variant={ environment === env ? 'contained' : 'outlined' }
                                        color={ environment === env ? getEnvironmentColor(env) : 'inherit' }
                                        onClick={ () => onEnvironmentToggle(env) }
                                        sx={ { textTransform: 'capitalize' } }
                                    >
                                        { env }
                                    </Button>
                                )) }
                            </ButtonGroup>
                        </Box>

                        <Button
                            variant="outlined"
                            startIcon={ <RefreshIcon /> }
                            onClick={ () => {
                                // trigger refetch by invalidating core queries
                                queryClient.invalidateQueries(['messages']);
                                queryClient.invalidateQueries(['preferences']);
                                queryClient.invalidateQueries(['shifts']);
                                queryClient.invalidateQueries(['queueStatus']);
                                queryClient.invalidateQueries(['systemStatus']);
                            } }
                        >
                            Refresh
                        </Button>

                        <ButtonGroup variant="contained">
                            <Button
                                startIcon={ <PlayArrowIcon /> }
                                onClick={ onProcessQueue }
                            >
                                Process Queue
                            </Button>
                            <Button
                                startIcon={ <ArchiveIcon /> }
                                onClick={ onArchiveMessages }
                            >
                                Archive Old
                            </Button>
                            <Button
                                startIcon={ <ClearIcon /> }
                                onClick={ onClearFailed }
                                color="warning"
                            >
                                Clear Failed
                            </Button>
                        </ButtonGroup>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ControlPanel;
